module.exports = __webpack_public_path__ + "media/images/flags/sn-aed5f269d0399710ad46d4f2e3ab3920.svg";